import React from 'react';
import { Link } from 'react-router-dom';
import Rating from './../review/Rating';

const FeatureImg = () => {
    return (
        <>
            <section className='image-feature pt-60 pb-120'>
                <div className='container'>
                    <div className='row justify-content-between align-items-center'>
                        <div className='col-lg-5 col-12 order-lg-1'>
                            <div className='feature-img-content'>
                                <div className='icon-box rounded-custom bg-dark shadow-sm d-inline-block'>
                                </div>
                                <h2>Managed SFTP Server – Secure, Hassle-Free File Transfers.</h2>
                                <p>
                                    Streamline secure file exchanges with our fully managed SFTP Server solution. Designed for businesses that require secure, compliant, and reliable file transfers, our Managed SFTP Server eliminates the burden of managing infrastructure, updates, and security protocols. Whether exchanging data with clients, partners, or internal teams, our solution ensures enterprise-grade protection and performance—so your team can stay focused on strategic priorities, not file transfer logistics.
                                </p>


                            </div>
                        </div>
                        <div className='col-lg-6 col-12 order-lg-0'>
                            <div className='feature-img-holder mt-4 mt-lg-0 mt-xl-0'>
                                <div className='testimonial-tab-content mb-5 mb-lg-0 mb-md-0'>
                                    <img
                                        src='/assets/img/testimonial/quotes-left.svg'
                                        alt='testimonial quote'
                                        width='65'
                                        className='img-fluid mb-32'
                                    />
                                    <div className='blockquote-title-review mb-4'>

                                        <Rating />
                                    </div>
                                    <blockquote className='blockquote'>
                                        The managed solution has been a game-changer for our team. We no longer worry about infrastructure or security—everything just works. It's allowed us to focus on what really matters: serving our clients.
                                    </blockquote>
                                    <div className='author-info mt-4'>
                                        <h6 className='mb-0'>Tim, R.</h6>
                                        <span>System administrator</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default FeatureImg;
